"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = require("react-select");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _async = require("react-select/async");

var _async2 = _interopRequireDefault(_async);

var _styledComponents = require("styled-components");

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const Dropdown = (_ref) => {
  let { isAsync } = _ref,
      props = _objectWithoutProperties(_ref, ["isAsync"]);

  const {
    options,
    onSelect,
    selected,
    placeholder,
    isMulti,
    loadOptions,
    theme,
    menuHeight
  } = props;

  const customStyles = {
    singleValue: base => _extends({}, base, {
      color: theme.colors.palette.ink["600"]
    }),
    placeholder: base => _extends({}, base, {
      color: theme.colors.palette.ink["600"]
    }),
    menuList: base => _extends({}, base, {
      maxHeight: menuHeight
    }),
    control: (base, state) => _extends({}, base, {
      minHeight: "40px",
      fontSize: `${theme.fontSizes[1]}px`,
      borderColor: state.isFocused ? theme.colors.palette.orange["400"] : theme.colors.palette.ink.lighter,
      "&:hover": {
        borderColor: theme.colors.palette.ink.lighterHover
      }
    }),
    indicatorSeparator: base => _extends({}, base, {
      display: "none"
    }),
    container: base => _extends({}, base, {
      fontFamily: theme.fonts.normal
    }),
    option: (provided, state) => _extends({}, provided, {
      fontSize: `${theme.fontSizes[1]}px`,
      color: theme.colors.palette.ink.normal,
      opacity: state.isDisabled ? 0.5 : 1,
      cursor: state.isDisabled ? "not-allowed" : "pointer"
    }),
    multiValue: provided => _extends({}, provided, {
      marginRight: `${theme.space[2]}px`,
      color: theme.colors.palette.ink.dark,
      lineHeight: "20px"
    }),
    multiValueLabel: base => _extends({}, base, {
      color: theme.colors.palette.ink.dark
    }),
    multiValueRemove: (base, state) => {
      return _extends({}, base, {
        display: state.data.removeIcon ? "none" : "flex"
      });
    },
    menu: provided => _extends({}, provided, {
      zIndex: 3
    })
  };

  const Component = isAsync ? _async2.default : _reactSelect2.default;

  /*Override the default No Options with custom message*/
  const NoOptionsMessage = props => _react2.default.createElement(
    _Flex2.default,
    { alignItems: "center", justifyContent: "center", height: 40 },
    _react2.default.createElement(
      _Text2.default,
      { fontSize: 1, color: "palette.ink.700" },
      props.children
    )
  );

  NoOptionsMessage.propTypes = {
    children: _propTypes2.default.node
  };

  return _react2.default.createElement(Component, _extends({}, props, {
    loadOptions: loadOptions,
    value: selected,
    onChange: selected => onSelect(selected),
    options: options,
    styles: customStyles,
    placeholder: placeholder,
    isMulti: isMulti,
    components: _extends({
      NoOptionsMessage
    }, props.components),
    theme: selectTheme => _extends({}, selectTheme, {
      colors: _extends({}, selectTheme.colors, {
        primary: theme.colors.palette.orange.light, // border focused
        primary25: theme.colors.palette.orange.lightHover, // option hover
        primary50: theme.colors.palette.orange.light, // option background onClick

        dangerLight: theme.colors.palette.orange.lightHover, // close background hover
        danger: theme.colors.palette.ink.dark, // close selected hover

        neutral10: theme.colors.palette.orange.light, //selected background
        neutral20: theme.colors.palette.ink.lightActive, // border color
        neutral50: theme.colors.palette.ink.lightActive, //placeholder
        neutral60: theme.colors.palette.ink.lightActive, // active dropdown arrow and clear all
        neutral80: theme.colors.palette.ink.normal // selected text
      })
    })
  }));
};

Dropdown.propTypes = {
  /** Required if it is isAsync */
  loadOptions: _propTypes2.default.func,
  /** Required if it isn't isAsync */
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.any.isRequired,
    label: _propTypes2.default.string.isRequired
  })),
  /** receives as argument the array of selected object. ex: `[{ label: 'Item 1', value: 'key1' }]`*/
  onSelect: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  selected: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    value: _propTypes2.default.any.isRequired,
    label: _propTypes2.default.string.isRequired
  }), _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.any.isRequired,
    label: _propTypes2.default.string.isRequired
  }))]),
  isMulti: _propTypes2.default.bool,
  theme: _propTypes2.default.object.isRequired,
  isAsync: _propTypes2.default.bool,
  noOptionsMessage: _propTypes2.default.func,
  components: _propTypes2.default.object,
  menuHeight: _propTypes2.default.string
};

Dropdown.defaultProps = {
  onSelect: Function.prototype,
  isAsync: false,
  noOptionsMessage: () => "No Results",
  menuHeight: "300px"
};

exports.default = (0, _styledComponents.withTheme)(Dropdown);